import produce from 'immer';
import { createPropsFinder, createPropsSelector } from './utils';

export const selectWorkingTimeModels = (state) => state.bo.workingTimeModels.workingTimeModels || produce([], () => {});

export const selectWorkingTimeModelsByProps = createPropsSelector(selectWorkingTimeModels);
export const findWorkingTimeModelsByProps = createPropsFinder(selectWorkingTimeModels);
